import React, { useEffect, useState } from 'react'

import { BiMoneyWithdraw } from 'react-icons/bi'
import { useLocation, useNavigate } from 'react-router-dom'

import { useModal, useProfessors, useStudents, useUser } from '../../context'
import { AdminMenu } from '../../types'
import { capitalizeFirstLetter } from '../../utilFunctions/transformFunc'
import { Button } from '../buttons'

import { NavbarContainer, NavbarLinkContainer } from './styles'

const InlineMenuHeader = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { modalStatus, setModalStatus } = useModal()

  useEffect(() => {
    // Verifica si la URL contiene los segmentos "/alumnos/", "/profesores/" o está en la página principal "/"
    const isAlumnos = location.pathname.includes('/alumnos')
    const isProfesores = location.pathname.includes('/profesores')
    const isNewUser = location.pathname.includes('/nuevo-usuario')

    if (!isAlumnos && !isProfesores) {
      setActiveItem('')
    }

    if (isAlumnos) {
      setActiveItem('alumnos')
    }

    if (isProfesores) {
      setActiveItem('profesores')
    }

    if (location.pathname === '/profile' || isNewUser) {
      setActiveItem('')
    }

    if (location.pathname === '/') {
      setActiveItem('administración')
    }
  }, [location])

  const { onEditionMode } = useUser()
  const { setActiveProfessor } = useProfessors()
  const { setActiveStudent } = useStudents()
  const [activeItem, setActiveItem] = useState('administración')

  const menu = Object.values(AdminMenu) as string[]

  const handleClick = (item: string) => {
    navigate(`/${item}`)
    setActiveItem(item)
    setActiveProfessor(null)
    setActiveStudent(null)
  }

  return (
    <NavbarContainer>
      <NavbarLinkContainer>
        {menu.map((item, i) => {
          if (item !== AdminMenu.bono) {
            return (
              <Button
                className={`inline-menu ${activeItem === item ? 'active' : undefined}`}
                onClick={() => handleClick(item)}
                disabled={onEditionMode}
                key={i}
                label={capitalizeFirstLetter(item)}
              />
            )
          } else {
            return (
              <Button
                className={`inline-menu ${activeItem === item ? 'active' : undefined}`}
                onClick={() => setModalStatus(!modalStatus)}
                key={i}
                disabled={onEditionMode}
                label={
                  <>
                    {/* <GrAdd /> */}
                    <BiMoneyWithdraw />
                    Agregar Bono
                  </>
                }
              />
            )
          }
        })}
      </NavbarLinkContainer>
    </NavbarContainer>
  )
}

export default InlineMenuHeader
